// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

var getColumnSchema_0 = {
  column: {
    TAG: /* Text */0,
    _0: "Opt-in Timestamp"
  },
  accessor: (function ($$document) {
      return {
              TAG: /* Text */0,
              _0: DeccoUtils$Catalyst.DateUtils.t_encode($$document.startDateTime)
            };
    })
};

var getColumnSchema_1 = {
  hd: {
    column: {
      TAG: /* Text */0,
      _0: "Opt-out Timestamp"
    },
    accessor: (function ($$document) {
        return {
                TAG: /* Text */0,
                _0: Belt_Option.mapWithDefault($$document.endDateTime, "", (function (x) {
                        return DeccoUtils$Catalyst.DateUtils.t_encode(x);
                      }))
              };
      })
  },
  tl: /* [] */0
};

var getColumnSchema = {
  hd: getColumnSchema_0,
  tl: getColumnSchema_1
};

function getView(serviceabilityInfo) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: serviceabilityInfo,
              children: (function (serviceabilityInfo) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: getColumnSchema,
                                    rowData: ReasonReactUtils$Catalyst.sliceList(Belt_Option.mapWithDefault(serviceabilityInfo.sessions, /* [] */0, (function (x) {
                                                return x;
                                              })), undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getColumnSchema ,
  getView ,
  
}
/* react Not a pure module */
